<template>
  <div class="annual-fee-renewal">
    <div class="service-introduction">
      <h1 class="title">年费会员服务介绍</h1>
      <div class="service-info">
        <img :src="require('@/assets/img/account/annual_fee_standard.png')" alt="" />
        <img :src="require('@/assets/img/account/annual_fee_excellent.png')" alt="" />
      </div>
    </div>
    <div class="package-config-box">
      <packageConfig
        :packageList="packageList"
        :type="1"
        :selectedPackageCode="selectedPackageCode"
        :selectedLimitCode="selectedLimitCode"
        @selectPackage="onSelectPackage"
        @selectLimit="onSelectLimit"
      />
    </div>
    <toPayFloatingBar
      btnText="提交订单"
      :orderStoreSum="orderStoreSum"
      :orderAmount="orderAmount"
      @btnClick="onBtnClick"
    />
  </div>
</template>

<script>
import packageConfig from '../../components/packageConfig/packageConfig.vue';
import toPayFloatingBar from '../../components/toPayFloatingBar/toPayFloatingBar.vue';
import { ANNUITY_TYPE } from '@/lib/constant';

export default {
  name: 'annualFeeRenewal',
  props: {
    storeAccoutnInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    isChain: {
      type: Number
    }
  },
  components: { packageConfig, toPayFloatingBar },
  computed: {
    orderAmount() {
      const {
        selectedPackage: { packageUnitPrice },
        selectedLimitCode,
        orderStoreSum
      } = this;
      if (!packageUnitPrice || !selectedLimitCode) return 0;
      return packageUnitPrice * selectedLimitCode * orderStoreSum;
    }
  },
  data() {
    return {
      packageList: [],
      selectedPackage: {},
      selectedPackageCode: null,
      selectedLimitCode: null,
      orderStoreSum: 1
    };
  },
  created() {
    this.getPackageConfig();
  },
  methods: {
    async getPackageConfig() {
      const res = await Fetch.getPackageConfig();
      this.packageList = res;
      // 标准版年费会员-默认选择「标准版」 -2年
      // 自助版年费会员-默认选择「标准版」-2年
      if ([ANNUITY_TYPE.STANDARD, ANNUITY_TYPE.SELF_SERVICE].includes(this.storeAccoutnInfo.annuityType)) {
        this.selectedPackageCode = ANNUITY_TYPE.STANDARD;
        this.selectedLimitCode = 2;
      } else {
        // 旗舰版年费会员-默认选择「旗舰版」 -1年 或者其他版本都是默认选择「旗舰版」 -1年
        this.selectedPackageCode = ANNUITY_TYPE.EXCELLENT;
        this.selectedLimitCode = 1;
      }
      this.selectedPackage = res.filter(v => v.packageCode === this.selectedPackageCode)[0];
    },
    onSelectPackage(packageInfo) {
      const { packageCode, defaultPackageLimitCode } = packageInfo;
      this.selectedPackage = packageInfo;
      this.selectedPackageCode = packageCode;
      this.selectedLimitCode = defaultPackageLimitCode;
      Telescope.trackEvent({ trackId: 'zywzpc-click-storeaccount-choosepackage' });
    },
    onSelectLimit(limitInfo) {
      this.selectedLimitCode = limitInfo.packageLimitTimeCode;
      Telescope.trackEvent({ trackId: 'zywzpc-click-storeaccount-renewalterm' });
    },
    onBtnClick() {
      Telescope.trackEvent({ trackId: 'zywzpc-click-storeaccount-submitorders' });
      const { selectedPackageCode, selectedLimitCode, orderAmount } = this;
      const params = {
        packageCode: selectedPackageCode,
        packageLimitTimeCode: selectedLimitCode,
        payPrice: orderAmount
      };
      this.$emit('payBtnClick', params);
    }
  }
};
</script>

<style lang="scss" scoped>
.annual-fee-renewal {
  display: flex;
  margin: 20px 0;
  .service-introduction {
    background: #fff;
    padding: 20px;
    flex: 1;
    .title {
      margin: 10px 0;
      font-size: 18px;
      font-weight: 600;
      color: #262626;
    }
    .service-info {
      img {
        width: 49%;
        &:first-child {
          margin-right: 2%;
        }
      }
    }
  }
}
</style>
